import { leadConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  me: null,
  patching: false
}

export default function lead(state = initialState, action) {
  switch (action.type) {
    case leadConstants.LEAD_SAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      }
    case leadConstants.LEAD_SAVE:
      return {
        ...state,
        me: null,
        loading: true
      }
    case leadConstants.LEAD_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        me: action.payload,
        success: true
      }
    case leadConstants.LEAD_RESET:
      return {
        ...initialState
      }
    case leadConstants.LEAD_PATCH:
      return { ...state, patching: true }
    case leadConstants.LEAD_PATCH_SUCCESS:
      return {
        ...state,
        me: null,
        patching: false
      }
    case leadConstants.LEAD_PATCH_FAILURE:
      return {
        ...state,
        error: action.payload,
        me: null,
        patching: false
      }
    default:
      return state
  }
}
